import { useState, useEffect } from 'react';

export const XS_BREAKPOINT = 767; // <= 767px
export const S_BREAKPOINT = 1023; // 768-1023px
export const M_BREAKPOINT = 1439; // 1024-1439px
export const L_BREAKPOINT = 1767; // 1440p-1767x

type BreakpointSize = 'XS' | 'S' | 'M' | 'L' | 'XL';

interface ResizeObj {
	windowSizeWidth: number | undefined;
	breakpoint: BreakpointSize;
}

export function useWindowReSize(): ResizeObj {
	const [windowSizeWidth, setWindowSize] = useState<any>(undefined);
	const [breakpoint, setBreakpoint] = useState<BreakpointSize>('XL');

	useEffect(() => {
		function handleResize(): void {
			setWindowSize(document.documentElement.clientWidth);

			if (window.innerWidth <= XS_BREAKPOINT) {
				setBreakpoint('XS');
			} else if (window.innerWidth <= S_BREAKPOINT) {
				setBreakpoint('S');
			} else if (window.innerWidth <= M_BREAKPOINT) {
				setBreakpoint('M');
			} else if (window.innerWidth <= L_BREAKPOINT) {
				setBreakpoint('L');
			} else {
				setBreakpoint('XL');
			}
		}
		// Add event listener
		window.addEventListener('resize', handleResize);
		// Call handler right away so state gets updated with initial window size
		handleResize();
		// Remove event listener on cleanup
		return (): void => window.removeEventListener('resize', handleResize);
	}, []); // Empty array ensures that effect is only run on mount
	return { windowSizeWidth, breakpoint };
}
